import LoadingWrapper from './LoadingWrapper'

export default LoadingWrapper
